import { Link } from "react-router-dom";

import Logo from "@/components/shared/Logo";
import { useI18n } from "@/lib/i18n";
import { buildFaqPath } from "@/lib/faq-route";
import { buildPlanComparisonPath } from "@/lib/plan-comparison";
import { MIN_PUBLIC_INFO_NAV, buildMinPublicInfoPath } from "@/lib/min-public-info-navigation";

export default function Footer() {
  const { locale, tx } = useI18n();
  const planComparisonPath = buildPlanComparisonPath(locale);
  const faqPath = buildFaqPath(locale);

  return (
    <footer className="landing-footer">
      <div className="landing-shell landing-footer__inner">
        <div className="landing-footer__brand">
          <Logo size="lg" variant="white" />
          <p>{tx("Min · 1 month of Fun free for everyone.")}</p>
        </div>
        <nav className="landing-footer__links" aria-label={tx("Footer navigation")}>
          <Link to={faqPath}>{tx("FAQs")}</Link>
          <Link to={planComparisonPath}>{tx("Compare Plans")}</Link>
          {["support", "privacy", "terms"].map((page) => <Link key={page} to={buildMinPublicInfoPath(locale, page)}>{MIN_PUBLIC_INFO_NAV[locale][page]}</Link>)}
        </nav>
        <p className="landing-footer__copyright">
          © {new Date().getFullYear()} Min
        </p>
      </div>
    </footer>
  );
}
